import axios from "axios";

const UrlDev = process.env.REACT_APP_URl;


export const GetPropertyDesc = async (filter: any, page: number) => {
    const response = await axios.post(UrlDev + "/description&title", { "page": page, "perPage": 8, "filterOptions": filter }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const GetTemplatesDesc = async (filter: any, page: number) => {
    const response = await axios.post(UrlDev + "/templatesdescription&title", { "page": page, "perPage": 8, "filterOptions": filter }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const SavePropertyDesc = async (obj: any) => {
    const response = await axios.post(UrlDev + "/savedescription&title", obj, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}
export const DeleteTemplateServ = async (id: any) => {
    const apiUrl = UrlDev + "/templatedescription&title";
    const response = await axios.delete(apiUrl + "/" + id, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const DeleteDescriptionServ = async (id: any) => {
    const apiUrl = UrlDev + "/description&title";
    const response = await axios.delete(apiUrl + "/" + id, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const DeleteDescriptionsServ = async (ids: any) => {
    const apiUrl = UrlDev + "/description&title/bulk";
    const response = await axios.post(apiUrl, { ids: ids }, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const UploadCsvTemplates = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const apiUrl = UrlDev + "/upload-csv-desandtitle";
    const response = await axios.post(apiUrl, formData, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}
export const UploadCsvListing = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    const apiUrl = UrlDev + "/upload-csv-listingcreation";
    const response = await axios.post(apiUrl, formData, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

export const UpdateTemplateServ = async (template: any, id: any) => {
    const apiUrl = UrlDev + "/templatedescription&title/";
    const response = await axios.put(apiUrl + id, template, {
        headers : {   
            "Authorization": "Bearer " + localStorage.getItem("usertoken")
        }
    })
    return response.data;
}

